import * as yup from 'yup';

export const supervisorUpdOTSchema = yup.object({
  celular: yup.string().required('El celular es requerido'),

  ///* fk ------------
  plan: yup
    .number()
    .typeError('El plan debe ser un número')
    .required('El plan es requerido'),

  forma_pago: yup.string().required('La forma de pago es requerida'), // code

  promocion: yup.string().required('La promoción es requerida'), // preventa
});
